import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useAppSelector} from '@/hooks';

export function useGetNumberOfHighlightedRows(): number | undefined {
  const activeItemId = useSingleActivePosterItemId() ?? '';

  return useAppSelector((state) => {
    const item = state.posterEditor.posterObject?.pages.pagesHashMap[state.posterEditor.currentPageId]?.items.itemsHashMap[activeItemId];

    if (item && 'layoutDataMap' in item && 'highlight' in item.layoutDataMap && item.layoutDataMap.highlight) {
      let sum = 0;
      for (const eachRow of item.layoutDataMap.highlight) {
        sum += eachRow.value ? 1 : 0;
      }
      return sum;
    }

    return undefined;
  });
}
